import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Breadcrumb, CrudService, MessageService, SharedDataService, AclService } from 'elbuild-ui-lib-core';
import { Company, Employee, User, UserType, Icons } from 'toolbandi-ui-lib';

import { EmployeePersonalEditComponent } from '../employee-personal-edit/employee-personal-edit.component';
import { EmployeeSalaryEditComponent } from '../employee-salary-edit/employee-salary-edit.component';

@Component({
	selector: 'app-employee-view',
	templateUrl: './employee-view.component.html',
	styleUrls: ['./employee-view.component.scss']
})
export class EmployeeViewComponent implements OnInit, OnDestroy {


	loading: boolean = false;
	employee: Employee;
	tab: string;

	keys: string[];
	canvalidate: boolean;
	breadcrumb: Breadcrumb;

	error: boolean;
	showcosts: boolean;

	constructor(private crudService: CrudService<Employee>,
		private companyService: CrudService<Company>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		private aclService: AclService) {
		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.canvalidate = ((data as User).utype === UserType.admin);
			}
		});

		this.aclService.hasPermission('employeecosts').subscribe((r: boolean) => {
			this.showcosts = r;
		});

	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
			this.tab = params['tab'];
		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.crudService.getEntity(Employee, 'employee', id).subscribe(employee => {
			this.loading = false;
			this.employee = employee;
			if (this.employee) {
				this.error = false;
				this.createKeys();
				this.setBreadcrumb();
			} else {
				this.error = true;
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.employee'));
			this.employee = undefined;
			this.error = true;
			this.loading = false;
		});
	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.employee.company.name, url: '/company/view/' + this.employee.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
		];
		this.breadcrumb.addData('docinvalid', !this.employee.docvalid);
		this.breadcrumb.title = { title: 'labels.view-employee', param: this.employee.fullname, icon: Icons.EMPLOYEE, icontooltip: 'labels.employee' };
	}


	createKeys(): void {
		this.keys = Object.keys(this.employee);
		const exclude = ['fname', 'lname', 'birthdate', 'joindate', 'company', 'insdate', 'moddate', 'companyid', 'id', 'docvalid', 'etype'];
		this.keys = this.keys.filter(k => this.employee[k] && exclude.indexOf(k) < 0);
	}



	editPersonal() {
		const modal = this.modalService.open(EmployeePersonalEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.employee.company.id;
		modal.componentInstance.load(this.employee.id);

		modal.result.then((newItem: Employee) => {
			this.load(this.employee.id);
		}).catch(() => { });
	}

	editSalary() {
		const modal = this.modalService.open(EmployeeSalaryEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.employee.company.id;
		modal.componentInstance.load(this.employee.id);

		modal.result.then((newItem: Employee) => {
			this.load(this.employee.id);
		}).catch(() => { });
	}

	attachmentsChanged(): void {
		if (this.employee && this.employee.id) {
			this.crudService.getEntity(Employee, 'employee', this.employee.id).subscribe(employee => {
				this.breadcrumb.addData('docinvalid', !this.employee.docvalid);
				this.sharedDataService.addCommonData('docinvalid', !this.employee.docvalid);

			}, ({ error }) => {

			});
		}
	}


}
